// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css */
.app {
  display: flex;
  height: 100vh;
  width: 100vw;
  background-color: #F5F5F5;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.main-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* src/App.css */\n.app {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  background-color: #F5F5F5;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.main-content {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: 0;\n  overflow: hidden;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
